module.exports = __webpack_public_path__ + "img/lock-icon.ab972f95.png";